import React, { useState } from 'react';
import { Link2, Copy, Check } from 'lucide-react';

const GoogleDriveConverter = () => {
    const [driveUrl, setDriveUrl] = useState('');
    const [directUrl, setDirectUrl] = useState('');
    const [copied, setCopied] = useState(false);

    const convertUrl = (url) => {
        setDriveUrl(url);

        // Extract file ID from Google Drive URL
        const match = url.match(/\/d\/([a-zA-Z0-9_-]+)/);
        if (match && match[1]) {
            const fileId = match[1];
            // Use a more reliable direct link format
            const converted = `https://lh3.googleusercontent.com/d/${fileId}`;
            setDirectUrl(converted);
        } else {
            setDirectUrl('');
        }
    };

    const copyToClipboard = () => {
        navigator.clipboard.writeText(directUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
            <div className="flex items-center gap-2 mb-3">
                <Link2 className="w-5 h-5 text-blue-600" />
                <h3 className="font-semibold text-blue-900">Google Drive URL Converter</h3>
            </div>

            <div className="space-y-3">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Paste Google Drive Link
                    </label>
                    <input
                        type="text"
                        value={driveUrl}
                        onChange={(e) => convertUrl(e.target.value)}
                        placeholder="https://drive.google.com/file/d/1ABC123.../view"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                    />
                </div>

                {directUrl && (
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Direct Image URL (Use this!)
                        </label>
                        <div className="flex gap-2">
                            <input
                                type="text"
                                value={directUrl}
                                readOnly
                                className="flex-1 px-3 py-2 border border-green-300 bg-green-50 rounded-lg text-sm font-mono"
                            />
                            <button
                                onClick={copyToClipboard}
                                className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors flex items-center gap-2"
                            >
                                {copied ? (
                                    <>
                                        <Check className="w-4 h-4" />
                                        Copied!
                                    </>
                                ) : (
                                    <>
                                        <Copy className="w-4 h-4" />
                                        Copy
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                )}
            </div>

            <div className="mt-3 text-xs text-gray-600">
                <p className="font-medium mb-1">How to use:</p>
                <ol className="list-decimal list-inside space-y-1">
                    <li>Upload image to Google Drive</li>
                    <li>Right-click → Get link → Anyone with link can view</li>
                    <li>Paste the link above</li>
                    <li>Copy the converted URL and use it in the image field below</li>
                </ol>
            </div>
        </div>
    );
};

export default GoogleDriveConverter;
